/**
 * The language line of the AI's system prompt. An explicit language choice
 * keeps the forced wording (`forcedRule`); a language only inferred from the
 * browser must not force, so the AI follows the user's latest message and uses
 * the inferred language only when that message has no clear language.
 */
export function languageRule(name: string, forced: boolean, forcedRule: string): string {
  const base = forced
    ? forcedRule
    : `Reply in the language of the user's latest message. If it has no clear language (a bare ticker, slang), reply in ${name}. Translate tool output into the language you reply in.`
  return `${base} ${WRITTEN_INTO_THE_APP}`
}

/**
 * Text the AI writes into the app follows the reply language too: a label is
 * not a reply, and an English user's line was labelled "水平线 (375)" (2026-10-18).
 */
const WRITTEN_INTO_THE_APP =
  'Text you write into the app (chart labels, notes, names) is in the language you reply in.'
